export default (roles) => {
  const BD_BOARD = {title: "BD Board", url: "/bd", icon: 'icon-svg_placeholder'};
  const MARKETING_BOARD = {title: "Marketing Board", url: "/marketing", icon: 'icon-svg_placeholder'};
  const REQUEST_REFUNDS = {title: "Request Refunds", url: "/refund-requestor", icon: 'icon-svg_request'};
  const REVIEW_REFUNDS = {title: "Review Refunds", url: "/refund-approver", icon: 'icon-svg_review'};
  const MANAGE_REFUNDS = {title: "Manage Refunds", url: "/refund-manager", icon: 'icon-svg_manage'};
  const EXPLORE_REFUNDS = {title: "Explore Refunds", url: "/refund-explorer", icon: 'icon-svg_explore'};
  const COMPLETED_REFUNDS = { title: "Explore Completed Refunds", url: "/refund-completed", icon: 'icon-svg_explore'};
  const ADMIN_SETTINGS = { title: "God-level Settings", url: "/admin-settings", icon: 'icon-svg_manage'};
  const SERVICE_MANAGER = { title: "Service Manager", url: "/service-manager", icon: 'icon-svg_manage'};
  const DNS_MANAGER = { title: "DNS Manager", url: "/domains", icon: 'icon-svg_manage' };
  const DNS_SEARCH = { title: "DNS Search", url: "/search", icon: 'icon-svg_manage' };

  const roleToMenuItems = {

    "SU": [
      BD_BOARD,
      MARKETING_BOARD,
      REQUEST_REFUNDS,
      REVIEW_REFUNDS,
      MANAGE_REFUNDS,
      EXPLORE_REFUNDS,
      COMPLETED_REFUNDS,
      ADMIN_SETTINGS,
      SERVICE_MANAGER,
      DNS_MANAGER,
      DNS_SEARCH
    ],
    "MGMT": [
      BD_BOARD,
      MARKETING_BOARD,
      REQUEST_REFUNDS,
      REVIEW_REFUNDS,
      MANAGE_REFUNDS,
      EXPLORE_REFUNDS,
      COMPLETED_REFUNDS
    ],
    "BD": [
      BD_BOARD,
    ],
    "OPT": [
      BD_BOARD,
      MARKETING_BOARD,
    ],
    "TECH": [
      BD_BOARD,
      MARKETING_BOARD,
      SERVICE_MANAGER
    ],
    "CC": [],
    "CC_LEVEL_1": [
      REQUEST_REFUNDS,
      COMPLETED_REFUNDS,
      EXPLORE_REFUNDS
    ],
    "CC_APPROVER": [
      REVIEW_REFUNDS
    ],
    "CC_MANAGER": [
      MANAGE_REFUNDS,
      EXPLORE_REFUNDS,
      COMPLETED_REFUNDS
    ],
    "DNS_MANAGER": [
      DNS_MANAGER,
      DNS_SEARCH      
    ],
    default: []
  };

  roleToMenuItems.CC_MANAGER_US = roleToMenuItems.CC_MANAGER_AE = roleToMenuItems.CC_MANAGER;
  roleToMenuItems.CC_APPROVER_US = roleToMenuItems.CC_APPROVER_AE = roleToMenuItems.CC_APPROVER;
  roleToMenuItems.CC_LEVEL_1_US = roleToMenuItems.CC_LEVEL_1_AE = roleToMenuItems.CC_LEVEL_1;

  if(!roles || !roles.length) return roleToMenuItems.default;
  return roles.reduce((acc, curr) => {
    const valuesToInclude = roleToMenuItems[curr].filter(item => !acc.map(menuItem => menuItem.title).includes(item.title))
    return [
      ...acc,
      ...valuesToInclude
    ]
  }, [])
}



// WEBPACK FOOTER //
// ./src/helpers/menuItems.js